import { NpvrNotificationsResponseNetworkModel } from '@norlys-a-s/norlys-play-kmm';

import { NpvrNotificationName, NpvrNotificationType } from '@smart-tv/typings/npvr';

import { kmm } from './kmm';

const { NotificationName, NotificationType } =
  NpvrNotificationsResponseNetworkModel.NotificationStripeDataNetworkModel;

export async function setNpvrNotificationState(
  notificationName: NpvrNotificationName,
  notificationType: NpvrNotificationType
): Promise<boolean> {
  return kmm(
    (repo) =>
      repo.setNpvrNotificationState(
        NotificationName.valueOf(notificationName),
        NotificationType.valueOf(notificationType)
      ),
    false
  );
}

export default setNpvrNotificationState;
